const contactForm = {
  displayField: 'header',
  name: 'Contact Form',
  description: 'Contact form',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Illustration',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'formId',
      name: 'Form ID',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'contactForm',
    version: 11,
    updatedAt: '2023-08-02T21:36:09.707Z'
  }
};
export default contactForm;